import React, { useEffect } from 'react'
import styled from 'styled-components'
import {
  ImgSet,
  Ingress,
  Payoff,
  SubHeader,
  ImageBlock,
  PageWrapper,
} from '../components/Utils'
import { colors } from '../variables'

import lights from '../img/photos/lights.jpg'
import lady from '../img/photos/lady_zoomedout.jpg'
import couple from '../img/photos/couple.jpg'
import { UIStore } from '../stores/UIStore'
import peter from '../img/photos/peter.png'
import { Container, Row, Col, Hidden } from 'react-grid-system'

const Developers = () => {
  useEffect(() => {
    UIStore.setBackgroundShade(colors.white)
  })

  return (
    <>
      <LandingArea />
      <PageWrapper
        style={{
          backgroundColor: colors.white,
        }}
      >
        <Container>
          <Row style={{ marginTop: 60 }}>
            <Hidden xs>
              <Col xs={12} sm={6}>
                <ImageBlock>
                  <ImgSet
                    img={lights}
                    style={{ top: 200, left: -80, width: 215 }}
                  />
                  <ImgSet img={lady} style={{ top: 0, left: 165 }} />
                  <ImgSet
                    img={couple}
                    style={{ top: 430, left: 165, width: 240 }}
                  />
                </ImageBlock>
              </Col>
            </Hidden>
            <Col xs={12} sm={6}>
              <StyledPayoff shade="dark">
                Vi levererar expertis och specialisering i framkant inom
                systemutveckling och lösningsarkitektur. Varje dag. Våra kunder
                idag har kärn&shy;verksamheter som är viktiga för både samhället
                och näringslivet och de förväntar sig att vi fortsatt håller oss
                där så de kan växa och bli större. Sveriges framtid säkrar vi
                tillsammans och vi levererar möjligheterna genom kod, samarbete
                och hållbarhet. En win - win - win. Vi kallar det den
                integrerade framgångs&shy;faktorn.
              </StyledPayoff>
            </Col>
          </Row>
          <StyledRow>
            <Col xs={12} sm={4}>
              <SubHeader shade="dark">Mer än lagom</SubHeader>
              <Ingress shade="dark">
                Vi tror på att omsätta ord till handling och vågar bygga och
                hitta lösningar för en ny way of working. Tiden när det räckte
                att fylla i någon enstaka uppföljning, blankett eller formulär
                ser vi är förbi. Men samarbete, expertstöd och öppenhet bygger
                nya konkurrensfördelar och är framtiden. I kod, i människa, i
                lönsamhet. För Sverige.
              </Ingress>
            </Col>
            <Col xs={12} sm={4}>
              <SubHeader shade="dark">
                Leveranssäkerhet &amp; kvalitet
              </SubHeader>
              <Ingress shade="dark">
                Varje konsult på uppdrag genom oss har ett kundteam bakom sig
                som stöttar och finns närvarande. Vi följer vårt ramverk inom
                kvalitet med alla våra kunder med de anpassningar som behövs.
                Genom löpande avstämningar med resursägare/ beställare och med
                konsulten ser vi till att agera proaktivt, ta till oss feedback
                och hantera både medgångar samt när saker inte alltid blivit som
                man tänkt sig.
              </Ingress>
            </Col>
            <Col xs={12} sm={4}>
              <SubHeader shade="dark">
                Utvecklarbolaget som leverantör
              </SubHeader>
              <Ingress shade="dark">
                Utöver vår tillgänglighet ser vi alltid vikten av ett gott
                samarbete och partnerskap med våra uppdragsgivare. Vi är ett
                affärsteam då vi agerar som det för att minska personliga
                beroenden och öka möjliga kontaktytor. Varje dag jobbar vi för
                att leverera expertstöd hos våra kunder och bistå i de mål ni
                har uppsatta - långsiktigt. “Succeeding above and beyond
                standard norms over the long-term".
              </Ingress>
            </Col>
          </StyledRow>
        </Container>
      </PageWrapper>
      <CustomerQuote
        quote={{
          img: peter,
          person: 'Peter Frey',
          title: 'CIO',
          company: 'Bonnier News',
          text:
            'Vi har jobbat med Utvecklarbolaget under lång tid och det är flexibla och professionella människor med hjärtat på rätta stället.',
        }}
      ></CustomerQuote>
    </>
  )
}

export const LandingArea = () => (
  <LandingHolder>
    <Container>
      <Row>
        <Col sm={9}>
          <h1>Mer än lagom - specialisering och expertstöd</h1>
        </Col>
      </Row>
    </Container>
  </LandingHolder>
)

type QuoteProps = {
  img: string
  person: string
  title: string
  company: string
  text: string
}

export const CustomerQuote = ({ quote }: { quote: QuoteProps }) => {
  return (
    <QuoteHolder>
      <QuoteImg img={quote.img} />
      <QuoteTextHolder>
        <div style={{ position: 'relative' }}>
          <Quotes style={{ top: '-5px', left: '-40px' }}>”</Quotes>
          <Quotes style={{ bottom: '30px', right: '-30px' }}>”</Quotes>
          <Payoff
            style={{ flexBasis: 'auto', width: 'auto', textAlign: 'center' }}
          >
            {quote.text}
          </Payoff>
          <span
            style={{
              display: 'inline-block',
              marginTop: 25,
              fontStyle: 'italic',
              fontSize: '18px',
              lineHeight: '26px',
            }}
          >
            {quote.person} &mdash; {quote.title}, {quote.company}
          </span>
        </div>
      </QuoteTextHolder>
    </QuoteHolder>
  )
}

const LandingHolder = styled.div`
  padding-top: 140px;
  box-sizing: border-box;
`

const StyledPayoff = styled(Payoff)`
  @media (min-width: 769px) {
    margin-left: 60px;
  }
`

const StyledRow = styled(Row)`
  margin-top: 60px;

  @media (min-width: 769px) {
    margin-top: 400px;
  }
`

const QuoteHolder = styled.section`
  display: flex;
  flex-direction: column;
  width: 100vw;
  margin-top: 60px;

  @media (min-width: 769px) {
    flex-direction: row;
    margin-top: 100px;
    height: 680px;
  }
`

const QuoteImg = styled.div`
  background-image: url(${({ img }: { img: string }) => img});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  min-width: 100vw;
  height: 300px;

  @media (min-width: 769px) {
    min-width: 50vw;
    height: 100%;
  }
`

const QuoteTextHolder = styled.div`
  background-color: ${colors.green};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: ${colors.white};
  width: 100%;
  height: 100%;
  padding: 70px;
  position: relative;
  text-align: center;
  box-sizing: border-box;

  @media (min-width: 769px) {
    padding: 0 120px;
    max-width: 50vw;
  }
`

const Quotes = styled.div`
  content: '”';
  position: absolute;
  color: ${colors.orange};
  font-size: 100px;
  line-height: 0;
`

export default Developers
